import Api from "@/services/api";
import { Contract, ContractDto } from "@/services/contracts/types";

export async function getContracts(): Promise<Array<Contract>> {
    return new Promise((resolve, reject) => {
        Api.get("/contracts").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function getContract(id: string): Promise<Contract> {
    return new Promise((resolve, reject) => {
        Api.get(`/contracts/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function updateContract(player: ContractDto): Promise<any> {
    return new Promise((resolve, reject) => {
        Api.put(`/contracts`, player).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};
